import React from 'react';
import { Table, TableBody, TableHead, TableRow } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import {
  GeneralTableBox,
  HeadTableCell,
  RowTableCell,
  CustomButton,
} from '../../../common/components';

/**
 * Tabla de datos para cartera mora sin casa.
 */
const MoraContractsDataTable = ({
  moraContractsCount,
  plans,
  groups,
  onEditContracts,
  onOpenDialog,
  isLoading,
  LoadingComponent,
}) => {
  const getGroupTotal = (groupUuid, isPremium) => {
    const withSubs = moraContractsCount?.with_subscribers?.[groupUuid] || {};
    const withoutSubs = moraContractsCount?.no_subscribers?.[groupUuid] || {};
    const withSubsCount = isPremium ? withSubs.premium_count || 0 : withSubs.regular_count || 0;
    const withoutSubsCount = isPremium
      ? withoutSubs.premium_count || 0
      : withoutSubs.regular_count || 0;
    return withSubsCount + withoutSubsCount;
  };

  const getNoGroupTotal = (planUuid, isPremium) => {
    const noGroup = moraContractsCount?.no_group?.[planUuid] || {};
    return isPremium ? noGroup.premium_count || 0 : noGroup.regular_count || 0;
  };

  const hasMoraContracts = (planUuid, isPremium = false) => {
    const hasGroupContracts = groups.some((group) => {
      if (group.uuid_plan !== planUuid) return false;
      return getGroupTotal(group.uuid, isPremium) > 0;
    });

    return hasGroupContracts || getNoGroupTotal(planUuid, isPremium) > 0;
  };

  const handleMoraContractsClick = async (planUuid, isPremium) => {
    onOpenDialog();
    await onEditContracts({
      archived: false,
      uuid_plan: planUuid,
      is_premium: isPremium,
      mora_quarantine: true,
    });
  };

  const renderPlanRow = (plan, isPremium) => {
    const planName = isPremium ? `${plan.name} Premium` : plan.name;
    return (
      <TableRow key={`mora-${plan.uuid}-${isPremium ? 'premium' : 'regular'}`}>
        <RowTableCell>{planName}</RowTableCell>
        <RowTableCell>
          {groups.map((group) => {
            if (group.uuid_plan !== plan.uuid) return null;
            const total = getGroupTotal(group.uuid, isPremium);
            if (total <= 0) return null;
            return (
              <React.Fragment key={`${plan.uuid}-${group.uuid}-${isPremium ? 'p' : 'r'}`}>
                <strong>{group.name}</strong>: {total}
                <br />
              </React.Fragment>
            );
          })}
          {getNoGroupTotal(plan.uuid, isPremium) > 0 && (
            <React.Fragment>
              <strong>SIN GRUPO</strong>: {getNoGroupTotal(plan.uuid, isPremium)}
              <br />
            </React.Fragment>
          )}
        </RowTableCell>
        <RowTableCell sx={{ textAlign: 'center' }}>
          <CustomButton
            variant="base"
            disabled={!hasMoraContracts(plan.uuid, isPremium)}
            onClick={() => handleMoraContractsClick(plan.uuid, isPremium)}
            buttonIcon={EditIcon}
            sx={{ paddingX: 5 }}
          />
        </RowTableCell>
      </TableRow>
    );
  };

  if (isLoading) {
    return <LoadingComponent />;
  }

  return (
    <GeneralTableBox>
      <Table aria-label="mora contracts table">
        <TableHead>
          <TableRow>
            <HeadTableCell wmd="25%">Nombre del plan</HeadTableCell>
            <HeadTableCell wmd="65%">Grupo</HeadTableCell>
            <HeadTableCell wmd="10%">Editar</HeadTableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {plans.flatMap((plan) => [renderPlanRow(plan, false), renderPlanRow(plan, true)])}
        </TableBody>
      </Table>
    </GeneralTableBox>
  );
};

export default MoraContractsDataTable;

